import React from 'react';
import '../styles/components/SNSAccounts.css';

function SNSAccounts({ formData, setFormData, loading }) {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="sns-accounts">
      <h3 className="sns-accounts__title">소유, 운영하고 있는 SNS 계정을 입력해주세요.</h3>

      <div className="sns-accounts__field">
        <label className="sns-accounts__label">인스타 ID (선택)</label>
        <input
          name="instagramId"
          placeholder="계정 명"
          value={formData.instagramId || ''}
          onChange={handleChange}
          disabled={loading}
          className="sns-accounts__input"
        />
      </div>

      <div className="sns-accounts__field">
        <label className="sns-accounts__label">블로그명 (선택)</label>
        <input
          name="blogName"
          placeholder="계정 명"
          value={formData.blogName || ''}
          onChange={handleChange}
          disabled={loading}
          className="sns-accounts__input"
        />
      </div>

      <div className="sns-accounts__field">
        <label className="sns-accounts__label">유튜브 채널명 (선택)</label>
        <input
          name="youtubeChannel"
          placeholder="계정 명"
          value={formData.youtubeChannel || ''}
          onChange={handleChange}
          disabled={loading}
          className="sns-accounts__input"
        />
      </div>

      <div className="sns-accounts__field">
        <label className="sns-accounts__label">틱톡ID (선택)</label>
        <input
          name="tiktokName"
          placeholder="계정 명"
          value={formData.tiktokName || ''}
          onChange={handleChange}
          disabled={loading}
          className="sns-accounts__input"
        />
      </div>
    </div>
  );
}

export default SNSAccounts;